import type * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * The one piece of chrome every aside shares: a bordered panel on the muted
 * surface. Everything *inside* is the page's own JSX, deliberately — the
 * goal of the aside slot is visual variety, and a data union describing
 * "title + bullets" would flatten the stats and testimonial asides into the
 * shape of the tips one.
 */
export function AsideCard({
  className,
  children,
}: {
  className?: string
  children: React.ReactNode
}) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border bg-muted/40 p-4',
        className,
      )}
    >
      {children}
    </div>
  )
}
